module.exports = __webpack_public_path__ + "img/03.8e9cfba6.jpg";